import { Injectable } from '@angular/core';
import { VacationFormErrors } from '../models/vacation-form-data.interface';

@Injectable({
  providedIn: 'root'
})
export class ErrorStateManagementService {
  airportErrorMessage = '';
  datesErrorMessage = '';
  tooFewPeopleErrorMessage = '';
  maxDatesErrorMessage = '';
  errorCount = 0;
  firstErrorElement: HTMLElement | null = null;

  updateErrorState(
    errors: VacationFormErrors,
    result: {
      airportErrorMessage: string;
      datesErrorMessage: string;
      tooFewPeopleErrorMessage: string;
      errorCount: number;
      firstErrorElement: HTMLElement | null;
    }
  ): void {
    this.airportErrorMessage = result.airportErrorMessage;
    this.datesErrorMessage = result.datesErrorMessage;
    this.tooFewPeopleErrorMessage = result.tooFewPeopleErrorMessage;
    this.maxDatesErrorMessage = errors.maxDatesError;
    this.errorCount = result.errorCount;
    this.firstErrorElement = result.firstErrorElement;
  }

  resetErrors(): void {
    this.airportErrorMessage = '';
    this.datesErrorMessage = '';
    this.tooFewPeopleErrorMessage = '';
    this.maxDatesErrorMessage = '';
    this.errorCount = 0;
    this.firstErrorElement = null;
  }
}
